import { useQuery } from '@tanstack/react-query'
import { getDemandWorkflowById } from 'services/demands/demandsServices'

export default function useDemandWorkflow(id) {
	const { data, isLoading, isError, error } = useQuery({
		queryKey: ['demand-workflow', id],
		queryFn: () => getDemandWorkflowById(id),
		enabled: !!id,
		staleTime: 1000 * 30,
		refetchOnWindowFocus: true,
		retry: false,
	})

	return { data, isLoading, isError, error }
}
